module.exports = __webpack_public_path__ + "static/media/x-icon.0c4b0b83.svg";